module.exports = __webpack_public_path__ + "static/img/bg-hex_trans.8576b5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-hex_trans.png
// module id = 659
// module chunks = 1